module.exports = __webpack_public_path__ + "static/facebook-21ec23814e110b1c18fc2e8c376d081a.svg";